import { PassportSituations } from '..'

const situations = [
  {
    title: 'mit barns pas udløber eller er udløbet',
    text: 'og jeg vil gerne bestille et nyt',
    id: PassportSituations.Renewal
  },
  {
    title: 'mit barn har ikke et pas',
    text: 'og jeg vil gerne bestille et',
    id: PassportSituations.New
  },
  {
    title: 'mit barns pas er beskadiget',
    text: 'og vil gerne bestille et nyt',
    id: PassportSituations.Damaged
  },
  {
    title: 'mit barns pas er bortkommet',
    text: 'f.eks. tabt eller blevet væk',
    id: PassportSituations.Lost
  },
  {
    title: 'mit barns pas er blevet stjålet',
    text: 'og jeg vil gerne anmelde det',
    id: PassportSituations.Stolen
  }
]

export default situations
